import { render } from "./ProjectEscrowWithdrawal.vue?vue&type=template&id=2873563d&scoped=true"
import script from "./ProjectEscrowWithdrawal.vue?vue&type=script&lang=js"
export * from "./ProjectEscrowWithdrawal.vue?vue&type=script&lang=js"

import "./ProjectEscrowWithdrawal.vue?vue&type=style&index=0&id=2873563d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2873563d"]])

export default __exports__